<template>
  <span class="email-subject-text" v-html="parsedMessage" />
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection.js'

export default {
  name: 'SubjectPreview',
  mixins: [variablesInspection],
}
</script>

<style lang="scss" scoped>
.email-subject-text {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
</style>
